import API from './API';

export default {

   getPartnerByEmployee(employeeId) {
    return API.get(`/employee?filter=id||$eq||${employeeId}&`,{
        params: {
             join: [
              'headquarters',
              'headquarters.partner'
            ], 
          },
        });
  }, 

  
  // Tariffe dei servizi sul motore a fasce. Cosa arriva lo decide il
  // backend: le tariffe Simba solo all'amministratore del partner.
  getPartnerTariffs() {
    return API.get('/tariff-band/partner-tariffs');
  },

  // Solo l'amministratore. Il server rifiuta (400) una tariffa sotto
  // quella Simba: il messaggio lo mostra la pagina.
  setPartnerTariffs(prices) {
    return API.put('/tariff-band/partner-tariffs', { prices }, { skipErrorToast: true });
  },

  // Listino valet: il backend restituisce le fasce del partner E quelle
  // generali di Simba; vale quello del partner, se ne ha uno.
  getValetBands() {
    return API.get('/valet-km-band', { params: { sort: 'from_km,ASC', limit: 100 } });
  },

  // Prezzi del venditore su una fascia del partner: i tre annuali e il €/km
  // dei km oltre il pacchetto. Il server rifiuta (400) un prezzo inferiore a
  // quello Simba: il messaggio lo mostra la pagina.
  setValetPartnerPrices(bandId, prices) {
    return API.patch(`/valet-km-band/${bandId}/partner-prices`, prices, { skipErrorToast: true });
  },

  // Stato dell'integrazione API del proprio partner (mai la chiave)
  getApiAccessStatus(partnerId) {
    return API.get(`/partner/${partnerId}/api-access`, { skipErrorToast: true });
  },

};